<template>
    <div class="border-top border-bottom py-4">
        <b-skeleton animation="fade" height="19px" width="220px" class="mb-3" />
        <b-skeleton animation="fade" height="14px" width="100%" />
        <b-skeleton animation="fade" height="14px" width="100%" />
        <b-skeleton animation="fade" height="14px" width="100%" v-if="isMobile" />
        <b-skeleton animation="fade" height="14px" width="50%" />
        <b-skeleton type="button" animation="fade" class="ml-auto mt-3" />
    </div>
</template>

<script>
    import mobileCheckMixin from "../../mixins/mobileCheckMixin";

    export default {
        name: "LifeTransitionsWidgetSkeleton",
        mixins: [mobileCheckMixin]
    }
</script>